// @ts-strict-ignore
import { AfterViewChecked, Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  standalone: false,
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: `[edgeDuplicateRemover]`
})
export class EdgeDuplicateRemoverDirective implements OnInit, AfterViewChecked {

  @Input(`edgeDuplicateRemover`) edgeDuplicateRemover: string;

  constructor(private elRef: ElementRef) {
  }

  ngOnInit(): void {
  }

  ngAfterViewChecked(): void {
    const children = this.elRef.nativeElement.children;
    for (let i = 0; i < children.length; i++) {
      if (children[i].classList.contains(this.edgeDuplicateRemover)) {
        children[i].style.display = 'none';
      } else {
        break;
      }
    }
    for (let i = children.length - 1; i >= 0; i--) {
      if (children[i].classList.contains(this.edgeDuplicateRemover)) {
        children[i].style.display = 'none';
      } else {
        break;
      }
    }
  }
}
